export default __webpack_public_path__ + "static/explore-screen-f8105db3c9e12adfd5416a9354258b32.webp";